<template>
    <div class="box">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li><router-link :to="{ name: 'latest' }">หน้าแรก</router-link></li>
          <li><router-link :to="{ name: 'novels' }">นิยายทั้งหมด</router-link></li>
          <li class="is-active">
            <a href="#" aria-current="page">{{ novel.name }}</a>
          </li>
        </ul>
      </nav>
      <div class="card-image media-image">
        <img :src="novel['image-cover']">
      </div>
      <div class="card media" v-show="!isLoading && !isEmpty(novel)">
        <div class="card-content media-content">
          <div class="content">
            <h1>{{ novel['name-en'] }} {{ novel['name-th'] }}</h1>
            <div v-show="novel.names" class="content">
              <h3>ชื่ออื่นๆ</h3>
              {{ novel.names }}
            </div>
            <div v-show="novel.author" class="content">
              <h3>ผู้แต่ง</h3>
              {{ novel.author }}
            </div>
            <div v-show="novel.translator" class="content">
              <h3>ผู้แปล</h3>
              {{ novel.translator }}
            </div>
            <div v-show="novel.links">
              <h3>แหล่งที่มา</h3>
              <ul>
                <li v-for="obj in novel.links" :key="obj.name">
                  {{ obj.name }}: <a :href="obj.link">{{ obj.link }}</a>
                </li>
              </ul>
            </div>
            <h2>เนื้อเรื่อง</h2>
            <p>{{ novel.description }}</p>
          </div>
          <header class="card-header" v-show="novel.hasOwnProperty('subscriptions') && donateTotal > 0">
            <a class="card-header-title">ระดับขั้นของท่าน</a>
            <p class="card-header-icon has-text-emerald">{{ mySubscriptionName(novel) }}</p>
          </header>
          <footer class="card-footer">
            <button class="button is-primary is-fullwidth is-radiusless" v-if="!novel.hasOwnProperty('subscriptions')" disabled>เรื่องนี้ยังไม่เปิดสนับสนุน</button>
            <button class="button is-primary is-fullwidth is-radiusless" v-else @click="$router.push({ name: 'subscriptions', params: { initialSelectedNovel: novel } })">
              <p v-if="donateTotal > 0">เลื่อนระดับขั้น</p>
              <p v-else>สมัครเข้าฝึกเซียน</p>
            </button>
          </footer>
        </div>
      </div>
      <b-tabs class="section" type="is-boxed is-toggle is-fullwidth" v-model="tabsSelected" v-show="novel.list" >
          <b-tab-item v-for="(section, index) in novel.list" :key="index" :label="section.name" :icon="iconList(index)">
          </b-tab-item>
      </b-tabs>
      <b-table class="is-fullwidth"
      :data="chapters"
      :loading="isLoading"
      hoverable
      paginated
      backend-pagination
      :current-page.sync="pagination.currentPage"
      :total="total"
      default-sort="chapter"
      :per-page="pagination.perPage"
      @page-change="onPageChange"
      >
        <template slot-scope="props">
          <b-table-column field="chapter" label="ตอนที่" centered numeric>
            <p class="button is-primary"
              @click="$router.replace({ name: 'chapter', params: { novelId: novelId, chapterId: props.row.chapter.toString() } })">
              อ่านตอน{{ isFree(props.row) ? 'ฟรี' : '' }} {{  props.row['chapter'] }}
            </p>
          </b-table-column>
          <b-table-column label="เรื่อง" centered>
              {{  novel.name }}
          </b-table-column>
          <b-table-column field="author" label="ผู้แปล" centered>
            <span class="tag">{{ props.row.author }}</span>
          </b-table-column>
          <b-table-column field="date" label="ลงวันที่">
            <span class="tag is-success">
                {{ dateFormatted(props.row['post_date']) }}
            </span>
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <div v-if="isLoading">
                <p>กำลังโหลด...</p>
              </div>
              <div v-else>
                <p><i class="far fa-sad-tear"></i></p>
                <p>{{ novel.name }} {{ novelListName }} ไม่พบตอนที่เลือก</p>
              </div>
            </div>
          </section>
        </template>
      </b-table>
    </div>
</template>

<script>
import { db } from '@/firebase.config'

export default {
  props: {
    novelId: String
  },
  metaInfo () {
    return {
      title: this.novel.name,
      meta: [
        { property: 'og:title', content: this.novel.name },
        { property: 'og:description', content: this.novel['name-en'] + '' + this.novel['name-th'] },
        { property: 'og:image', content: this.novel['image-cover'] },
        { property: 'og:url', content: this.$route.fullPath }
      ]
    }
  },
  data () {
    return {
      isLoading: false,
      tabsSelected: 0,
      novel: {},
      chapters: [],
      chaptersRef: [],
      pagination: {
        currentPage: 1,
        perPage: 20
      },
      chapterLatest: []
    }
  },
  firestore () {
    return {
      chapterLatest: db.collection('chapters').where('novel_id', '==', this.novelId).where('status', '==', 'public').orderBy('chapter', 'desc').limit(1)
    }
  },
  computed: {
    total () {
      if (this.novel.list) {
        var selected = this.novel.list[this.tabsSelected]
        if (this.chapterLatest.length > 0) {
          var latest = this.chapterLatest[0].chapter
          if (latest >= selected.from && latest <= selected.to) {
            return latest - selected.from
          }
        }
        return selected.to - selected.from
      }
      return this.chapters.length
    },
    toLatest () {
      if (this.novel.list) {
        var selected = this.novel.list[this.tabsSelected]
        if (this.chapterLatest.length > 0) {
          var latest = this.chapterLatest[0].chapter
          if (latest >= selected.from && latest <= selected.to) {
            return latest
          }
        }
        return selected.to
      }
      return this.chapters.length
    },
    donateTotal () {
      var completedPayments = this.$root.payments.filter(payment => payment.status === 'completed')
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    },
    novelListName () {
      if (this.novel.list) {
        return this.novel.list[this.tabsSelected].name
      }
      return ''
    },
    selectedList () {
      if (this.novel.list) {
        return this.novel.list[this.tabsSelected]
      }
      return {}
    }
  },
  methods: {
    loadAsyncData () {
      this.isLoading = true
      if (this.isEmpty(this.novel)) {
        this.loadNovelDetail()
        return
      }
      var query = db.collection('chapters').where('novel_id', '==', this.novelId).where('status', '==', 'public')
      if (this.novel.list) {
        query = db.collection('chapters')
          .where('novel_id', '==', this.novelId)
          .where('status', '==', 'public')
          .where('chapter', '>=', this.selectedList.from).where('chapter', '<=', this.selectedList.to)
          .orderBy('chapter', 'desc')
          .limit(this.pagination.perPage)
          .startAt(this.toLatest - ((this.pagination.currentPage - 1) * this.pagination.perPage))
      } else {
        query = query.orderBy('chapter', 'desc')
      }
      query
        .get()
        .then(snapshot => {
          this.chapters = snapshot.docs.map(doc => doc.data())
          this.chaptersRef = snapshot.docs
          this.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$dialog.alert({ title: 'เกิดข้อผิดพลาด!', message: error.toString(), type: 'is-danger' })
          this.isLoading = false
        })
    },
    loadNovelDetail () {
      db.collection('novels').where('isHidden', '==', false).where('id', '==', this.novelId)
        .get()
        .then(snapshot => {
          this.isLoading = false
          console.log(snapshot)
          if (snapshot.empty) {
            this.$root.$dialog.alert({
              title: 'เกิดข้อผิดพลาด',
              message: 'ไม่พบเรื่องที่ต้องการ',
              type: 'is-danger'
            })
          } else {
            this.novel = snapshot.docs[0].data()
            if (snapshot.docs[0].data().list) {
              this.novel.list = snapshot.data().list.reverse()
            }
            this.loadAsyncData()
          }
        })
        .catch(error => {
          console.log(error)
          this.$root.$dialog.alert({
            title: 'เกิดข้อผิดพลาด',
            message: error.toString(),
            type: 'is-danger'
          })
          this.isLoading = false
        })
    },
    onPageChange (page) {
      this.pagination.currentPage = page
      this.loadAsyncData()
    },
    isEmpty (obj) {
      return Object.keys(obj).length === 0
    },
    mySubscription (novel) {
      if (novel.subscriptions === undefined) { return }
      if (this.$root.isImmortal) {
        return novel.subscriptions.find(sub => sub.id === 'immortal')
      }
      return novel.subscriptions.find(sub => sub.price === this.donateTotal)
    },
    mySubscriptionName (novel) {
      var subscription = this.mySubscription(novel)
      if (subscription) {
        return subscription.name + ` (${subscription.price}${subscription.currency})`
      }
    },
    iconList (index) {
      return index === this.novel.list.length - 1 ? 'fas fa-fire' : 'far fa-file-alt'
    },
    dateFormatted (date) {
      var options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      return date.toDate().toLocaleDateString('en-GB', options)
    },
    isFree (row) {
      if (this.novel.chapterFree) {
        return row.chapter <= this.novel.chapterFree
      }
      return true
    }
  },
  mounted () {
    this.loadAsyncData()
  },
  watch: {
    tabsSelected (newIndex) {
      this.pagination.currentPage = 1
      this.loadAsyncData()
    }
  }
}
</script>

<style lang="scss">

</style>
